<template>
  <div>
    <div class="mb-6 pb-6 border-b-2 border-grey-light flex flex-wrap items-center">
      <div>
        <h1 class="text-grey-darker text-xl font-semibold leading-normal uppercase">
          Custom Print Orders
        </h1>
        <a
          v-if="officeAccess"
          @click="$router.push('/print-order-form')"
          class="text-grey-dark text-sm font-medium leading-normal cursor-pointer no-underline hover:underline">
          &lt; Order Another Product
        </a>
      </div>
    </div>

    <loader v-if="!loaded" />

    <!-- OFFICE HAS NO ACCESS -->
    <panel v-else-if="!officeAccess" class="pt-6">
      <strong class="mb-2">Access Denied</strong>
      <p>Your office does not currently have access to use the print order form.</p>
    </panel>

    <div v-else class="rounded-lg bg-white relative flex flex-col py-6 px-4">
      <div class="flex flex-wrap items-center leading-none pb-6 border-b-2 border-grey-light">
        <h3 class="flex w-full mb-4 lg:w-1/3 lg:mb-0">Custom Print Orders - {{ success ? 'Success' : 'Cancelled' }}</h3>
        <div class="w-full lg:w-2/3">
          <print-sub-menu />
        </div>
      </div>
      <div class="flex flex-wrap mt-8">
        <div class="mb-6 w-full lg:w-2/3">
          <div class="border border-grey-light">

            <!-- STAGE TABS -->
            <div class="w-full flex text-sm mb-6 bg-grey-lighter">
              <div class="flex flex-col w-1/3" :class="{'border-l border-r': i === 1}" v-for="(stageTab, i) in stages" :key="i">
                <div class="w-full h-full px-3 pt-3 pb-5 border-t-2" :class="[(i === stage ? 'border-t-2 border-print-order-teal bg-white' : 'border-transparent bg-grey-lighter')]">
                  <div class="flex h-full items-center">
                    <i class="fas ml-1 mr-2 text-lg text-print-order-teal" :class="stageTab.icon" />
                    <div class="text-sm">{{ stageTab.name }}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="w-full text-sm mb-2 p-4">
              <success v-if="success === true" :order="order" />
              <cancelled v-else :order="order" />
            </div>
          </div>
        </div>

        <div class="w-full lg:w-1/3 lg:pl-6">
          <p class="mt-4 mb-6 text-sm leading-normal"><a @click="$router.push('/print-order-form')" class="underline cursor-pointer">Order another product</a> or use the links above to view order history and saved items.</p>
          <div class="mb-6 px-4 text-center">
            <button class="w-full md:w-3/4 mb-6 py-4 text-xs border border-print-order-teal bg-print-order-teal hover:bg-print-order-teal-lightest text-white hover:text-print-order-teal focus:outline-none" @click="$emit('continueShopping')">
              Continue Shopping
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { v2Api } from '@/http'
import { isEmpty } from 'lodash'
import PrintSubMenu from './print-order-form/PrintSubMenu'
import Cancelled from './print-order-form/basket/Cancelled'
import Success from './print-order-form/basket/Success'
import { mapState, mapActions } from 'vuex'
export default {
  components: {
    PrintSubMenu,
    Success,
    Cancelled
  },
  data () {
    return {
      loaded: false,
      officeAccess: true,
      sessionId: null,
      order: null,
      success: null,
      stage: 2,
      stages: [
        {
          name: 'Basket - Order Details',
          icon: 'fa-shopping-cart'
        },
        {
          name: 'Delivery Address',
          icon: 'fa-truck'
        },
        {
          name: 'Order Success',
          icon: 'fa-check-circle'
        }
      ]
    }
  },
  computed: {
    ...mapState(['selectedOffice', 'profile'])
  },
  watch: {
    selectedOffice: {
      handler () {
        this.loadPage()
      },
      deep: true
    }
  },
  created () {
    this.loadPage()
  },
  methods: {
    isEmpty,
    ...mapActions([
      'displayToastNotification'
    ]),
    loadPage () {
      this.loaded = false
      this.sessionId = this.$route.query.session_id
      this.success = this.$route.query.result === 'success'
      if (!this.success) {
        this.stages[2] = {
          name: 'Order Cancelled',
          icon: 'fa-times-circle'
        }
      }
      Promise.all([
        this.loadOrder()
      ]).then(() => {
        this.loaded = true
      })
    },
    loadOrder () {
      let endpoint = this.success ? 'payment-successful' : 'payment-cancelled'
      return v2Api.post('custom-print-orders/' + endpoint, {
        session_id: this.sessionId
      }).then((response) => {
        this.order = response.data
        this.officeAccess = true
      }).catch(() => {
        this.officeAccess = false
      }).finally(() => {
        this.loaded = true
      })
    },
    continueShopping () {
      this.$router.push('/print-order-form')
    }
  }
}
</script>
